import { useEffect, useState } from 'react'
import { Input, Select } from 'antd'
import { API } from 'src/utils/interceptor'

export const sourceRowsForQuery = ({ results, resultsQuery, query }) =>
  resultsQuery === query ? results || [] : []

export const emptyMenuMessage = ({ kind, venueId, query, settled, count }) => {
  if (kind !== 'menu' || !venueId || !settled || count > 0) return ''
  if (String(query || '').trim()) return 'No menus match.'
  return 'This venue has no menus.'
}

export const PRODUCT_LOOKUP_NOTE =
  'The venue is where you look the product up. Every venue you can manage in the group that has it is updated.'

export const FIRST_TEN_NOTE = 'Showing the first 10. Type a name or code.'

export const productListHint = ({ kind, query, count }) =>
  kind === 'product' && !String(query || '').trim() && Number(count) > 0
    ? FIRST_TEN_NOTE
    : ''

export const sourceRadioName = ({ kind, label }) =>
  `${kind}-${label || 'source'}`

const SourcePicker = ({ venues, kind, multiple, chosen, onChange, label }) => {
  const [venueId, setVenueId] = useState('')
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [resultsQuery, setResultsQuery] = useState(null)

  useEffect(() => {
    if (!venueId) {
      setResults([])
      setResultsQuery(null)
      return undefined
    }
    let cancelled = false
    const searched = query
    const handle = setTimeout(() => {
      API.get(
        'api2',
        `venue-groups/source-search?kind=${kind}&venueId=${venueId}&q=${encodeURIComponent(
          searched,
        )}`,
      )
        .then(response => {
          if (cancelled) return null
          setResults(response?.data || [])
          setResultsQuery(searched)
          return null
        })
        .catch(() => {
          if (cancelled) return null
          setResults([])
          setResultsQuery(searched)
          return null
        })
    }, 250)
    return () => {
      cancelled = true
      clearTimeout(handle)
    }
  }, [venueId, query, kind])

  const visible = sourceRowsForQuery({ results, resultsQuery, query })
  const emptyMenus = emptyMenuMessage({
    kind,
    venueId,
    query,
    settled: resultsQuery === query,
    count: visible.length,
  })

  const selected = chosen || []
  const toggle = item => {
    const picked = { ...item, venueId }
    if (!multiple) {
      onChange([picked])
      return
    }
    onChange(
      selected.some(row => String(row._id) === String(item._id))
        ? selected.filter(row => String(row._id) !== String(item._id))
        : [...selected, picked],
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <label>{label || 'Source venue'}</label>
      <Select
        value={venueId || undefined}
        placeholder='Choose a venue'
        onChange={setVenueId}
        style={{ width: '100%', maxWidth: 360 }}
      >
        {(venues || []).map(venue => (
          <Select.Option key={venue._id} value={venue._id}>
            {venue.title}
          </Select.Option>
        ))}
      </Select>
      <Input
        value={query}
        onChange={event => setQuery(event.target.value)}
        placeholder='Name contains'
      />
      {selected.length > 0 && (
        <p>Chosen: {selected.map(item => item.title).join(', ')}</p>
      )}
      {emptyMenus && <p>{emptyMenus}</p>}
      {productListHint({ kind, query, count: visible.length }) && (
        <p>{productListHint({ kind, query, count: visible.length })}</p>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {visible.map(item => (
          <label key={item._id}>
            <input
              type={multiple ? 'checkbox' : 'radio'}
              name={multiple ? undefined : sourceRadioName({ kind, label })}
              style={{ marginRight: 8 }}
              checked={selected.some(
                row => String(row._id) === String(item._id),
              )}
              onChange={() => toggle(item)}
            />
            {item.title}
          </label>
        ))}
      </div>
    </div>
  )
}

export default SourcePicker
